import React from "react";
import { NavLink } from "react-router-dom";

const CollaboratorRolesList = ({ collaborators, filmId }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Collaborators in Role</p>
      <ul className="menu-list">
        {collaborators && !collaborators.length && <div>None</div>}
        {(collaborators || []).map((user, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/collaborators/${user.id}/edit`}
                title={user.name}
                activeClassName="is-active">
                {user.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default CollaboratorRolesList;
